import { z } from "zod";
import { siteContactNumberRegex } from "../../constants/regex";
import { zCodeListSchema, zEmailSchema, zString } from "./commonSchemaObjects";

export const centralLabSchema = z.object({
  central_lab_id: zString.zOptional,
  central_lab_name: zString.zRequired,
  street_address: zString.zRequired,
  unit_number: zString.zOptional,
  city: zString.zRequired,
  state: zString.zRequired,
  country: zCodeListSchema,
  postal_code: zString.zRequired,
  contact_name: zString.zRequired,
  contact_email: zEmailSchema,
  contact_phone_number: zString.zRequired
    .regex(siteContactNumberRegex, "Invalid contact phone number format"),
});
